class CrawlerDetailResponseDto {
  /** crawlerModel */
  crawlerModel = new CrawlerModel();

  /** taskModelList */
  taskModelList = [];
}

class CrawlerModel {
  /** 回调数据样式 1存储路径 2html样式 */
  callbackDataStyle = undefined;

  /** 回调方式 HTTP,RPC,MQ */
  callbackMethod = "";

  /** 回调状态 0未回调 1回调成功 2 回调失败 */
  callbackStatus = undefined;

  /** 回调地址 */
  callbackUrl = "";

  /** 爬虫失败原因 */
  crawlerError = "";

  /** 爬虫文件路径 */
  crawlerFilePath = "";

  /** 爬取域名 */
  crawlerHost = "";

  /** 爬取地址(包含参数) */
  crawlerUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 最后通知时间 */
  lastCallbackTime = "";

  /** 最后爬取时间 */
  lastCrawlerTime = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 最大重试次数 */
  maxRetryNumber = undefined;

  /** 是否解析成功 0失败 1成功 */
  parsingStatus = false;

  /** 代理方式 */
  proxy = "";

  /** 请求方唯一标识 */
  requestId = "";

  /** 请求方式 HTTP,RPC,MQ */
  requestMethod = "";

  /** 已重试次数 */
  retryNumber = undefined;

  /** 来源系统 */
  sourceSystem = "";

  /** 存储方式 oss：OSS存储; local:本地存储 */
  storageMode = "";

  /** 任务状态 0.未处理 1.待爬取 2.爬取成功 3爬取失败 4终止爬取 */
  taskStatus = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CrawlerRequestDto {
  /** 回调数据样式 1存储路径 2html样式 */
  callbackDataStyle = "HTML";

  /** 回调方式 HTTP,RPC,MQ */
  callbackMethod = "HTTP";

  /** 回调地址 */
  callbackUrl = "";

  /** 爬取地址(包含参数) */
  crawlerUrl = "";

  /** 最大重试次数,默认三次 */
  maxRetryNumber = undefined;

  /** 代理方式,默认快代理 'vps' | 'vite' 快代理 | 'native' 不使用代理 */
  proxy = "NATIVE";

  /** 请求方唯一标识 */
  requestId = "";

  /** 来源系统 */
  sourceSystem = "GJ_REVIEW";

  /** 存储方式 oss：OSS存储; local:本地存储 */
  storageMode = "LOCAL";
}

class CrawlerRequestParamsDto {
  /** 回调状态 0未回调 1回调成功 2 回调失败 */
  callbackStatus = "";

  /** 回调地址 */
  callbackUrl = "";

  /** 爬虫失败原因 */
  crawlerError = "";

  /** 爬虫文件路径 */
  crawlerFilePath = "";

  /** 爬取域名 */
  crawlerHost = "";

  /** 爬取地址(包含参数) */
  crawlerUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间开始时间 */
  createTimeGe = "";

  /** 创建时间结束时间 */
  createTimeLe = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 最后通知时间开始时间 */
  lastCallbackTimeGe = "";

  /** 最后通知时间结束时间 */
  lastCallbackTimeLe = "";

  /** 最后爬取时间开始时间 */
  lastCrawlerTimeGe = "";

  /** 最后爬取时间结束时间 */
  lastCrawlerTimeLe = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 最大重试次数 */
  maxRetryNumber = undefined;

  /** 请求方式 HTTP,RPC,MQ */
  requestMethod = "";

  /** 已重试次数 */
  retryNumber = undefined;

  /** 来源系统 */
  sourceSystem = "";

  /** 任务状态 0.未处理 1.待爬取 2.爬取中 3.爬取成功 4爬取失败 5.终止爬取 */
  taskStatus = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CrawlerResponseDto {
  /** 回调状态 0未回调 1回调成功 2 回调失败 */
  callbackStatus = "";

  /** 回调地址 */
  callbackUrl = "";

  /** 爬虫失败原因 */
  crawlerError = "";

  /** 爬虫文件路径 */
  crawlerFilePath = "";

  /** 爬取域名 */
  crawlerHost = "";

  /** 爬取地址(包含参数) */
  crawlerUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 最后通知时间 */
  lastCallbackTime = "";

  /** 最后爬取时间 */
  lastCrawlerTime = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 最大重试次数 */
  maxRetryNumber = undefined;

  /** 请求方式 HTTP,RPC,MQ */
  requestMethod = "";

  /** 已重试次数 */
  retryNumber = undefined;

  /** 来源系统 */
  sourceSystem = "";

  /** 任务状态 0.未处理 1.待爬取 2.爬取中 3.爬取成功 4爬取失败 5.终止爬取 */
  taskStatus = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CrawlerTaskModel {
  /** 爬虫ID */
  crawlerId = undefined;

  /** 爬虫地址 */
  crawlerUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 文件存放地址 */
  filePath = "";

  /** 主键 */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 网络状态码 */
  networkStatusCode = "";

  /** 是否解析成功 0失败 1成功 */
  parsingStatus = false;

  /** 请求方唯一标识 */
  requestId = "";

  /** 抓取Ip */
  taskIp = "";

  /** 抓取信息 */
  taskMsg = "";

  /** 抓取开始时间 */
  taskStartTime = "";

  /** 任务状态 0.未处理 1.待爬取 2.爬取中 3.爬取成功 4爬取失败 5.终止爬取 */
  taskStatus = undefined;

  /** 抓取成功时间 */
  taskSuccessTime = "";

  /** 任务类型 1正常 2重试 */
  taskType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";

  /** 权重 5,4,3,2,1 */
  weight = undefined;
}

class CrawlerTaskRequestParamsDto {
  /** 爬虫ID */
  crawlerId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 文件存放地址 */
  filePath = "";

  /** 主键 */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 网络状态码 */
  networkStatusCode = "";

  /** 抓取错误 */
  taskError = "";

  /** 抓取Ip */
  taskIp = "";

  /** 抓取开始时间 */
  taskStartTime = "";

  /** 抓取结果 0未抓取 1抓取中 2抓取成功 3抓取失败 4.终止抓取 */
  taskStatus = undefined;

  /** 抓取成功时间 */
  taskSuccessTime = "";

  /** 任务类型 0正常 1重试 */
  taskType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CrawlerTaskResponseDto {
  /** 爬虫ID */
  crawlerId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 文件存放地址 */
  filePath = "";

  /** 主键 */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 网络状态码 */
  networkStatusCode = "";

  /** 抓取错误 */
  taskError = "";

  /** 抓取Ip */
  taskIp = "";

  /** 抓取开始时间 */
  taskStartTime = "";

  /** 抓取结果 0未抓取 1抓取中 2抓取成功 3抓取失败 4.终止抓取 */
  taskStatus = undefined;

  /** 抓取成功时间 */
  taskSuccessTime = "";

  /** 任务类型 0正常 1重试 */
  taskType = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new CrawlerDetailResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

export const crawler = {
  CrawlerDetailResponseDto,
  CrawlerModel,
  CrawlerRequestDto,
  CrawlerRequestParamsDto,
  CrawlerResponseDto,
  CrawlerTaskModel,
  CrawlerTaskRequestParamsDto,
  CrawlerTaskResponseDto,
  IPage,
  Response,
  ResponseDto,
};
